import { WebComponent } from '@cian/mf-registry/browser';
import * as React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';

import { Application } from '../../shared/containers/App';
import type { IApplicationContext } from '../../shared/types/applicationContext';
import { TReduxStore } from '../../shared/types/redux';

export function createCustomElementConstructor(
  context: IApplicationContext,
  store: TReduxStore,
): CustomElementConstructor {
  class Footer extends WebComponent {
    private applicationContext?: IApplicationContext;

    protected microfrontendName = context.config.getStrict<string>('projectName');
    protected imageVersion = '';
    protected runtimeName = '/v1/get-footer-microfrontend/';

    public async connectedCallback(): Promise<void> {
      const instanceId = this.getAttribute('instance') || undefined;
      this.applicationContext = { ...context, config: context.config.attach({ instanceId }) };
      this.imageVersion = this.applicationContext.config.getStrict<string>('version.commit');
      super.connectedCallback();
    }

    public async render() {
      const reactElement = <Application context={this.applicationContext as IApplicationContext} reduxStore={store} />;

      if (this.shouldHydrate) {
        hydrateRoot(this, reactElement);
      } else {
        createRoot(this).render(reactElement);
      }
    }
  }

  return Footer;
}
